<script setup>
import { getFilterState } from "@/js/services/CampaignService";
import { computed } from "vue";

defineEmits(["click"]);

const props = defineProps({
	skipLeadConditions: {
		type: Array,
		required: true,
	},
	isChips: {
		type: Boolean,
		required: false,
	}
});

const getIconColor = computed(() => {
	return props.isChips || getFilterState(props.skipLeadConditions) === "FILTER_EMPTY" ? undefined : "var(--main-primary)";
});

function filterIconName() {
	switch (getFilterState(props.skipLeadConditions)) {
	case "FILTER_EMPTY" : return "filter-empty";
	case "FILTER_AI_POWERED" : return "filter-ai-powered";
	case "FILTER_LONG" : return "filter-long";
	case "FILTER_SHORT" : return "filter-short";
	default: return "filter-empty";
	}
}

function filterTooltipText() {
	switch (getFilterState(props.skipLeadConditions)) {
	case "FILTER_EMPTY" : return "View lead filtering rules";
	case "FILTER_AI_POWERED" : return "You have added AI filters";
	case "FILTER_LONG" : return "View lead filtering rules";
	case "FILTER_SHORT" : return "View lead filtering rules";
	default: return "View lead filtering rules";
	}
}

</script>

<template>
	<span
		v-tooltip="filterTooltipText()"
		class="leads-filters-button"
		:class="{'is-chips': isChips }"
		@click="$emit('click')"
	>
		<Icon
			:icon="filterIconName()"
			:fill="getIconColor"
		/>
	</span>
</template>

<style lang="sass">
.leads-filters-button
	cursor: pointer
	border-radius: var(--bdrs-L)
	display: flex
	justify-content: center
	align-items: center
	padding: 2px 8px

	&.is-chips
		background-color: var(--neutral-200)
</style>
